import { Select } from 'antd'
import {SOFT_PHONE_EVENTS, triggerEvent, useSoftPhoneStore} from "@shj/use-soft-phone";

export default function ExtenTypeSelect(props: any) {
  const softPhone = useSoftPhoneStore(state => state?.softPhone)
  const updateSoftPhoneAttr = useSoftPhoneStore(state => state?.updateSoftPhoneAttr)

  const handleChange = (value) => {
    updateSoftPhoneAttr('extenType', value)
    triggerEvent(SOFT_PHONE_EVENTS.SWITCH_EXTEN_TYPE, { extenType: value })
    props.onChange?.()
  }

  return (
    <Select
      // fillAs="label"
      // name="extenType"
      style={props.style || { width: '135px' }}
      onChange={handleChange}
      value={softPhone.extenType}
      placeholder="接听方式"
      options={softPhone.answerWay}
      fieldNames={{ value: 'id' }}
    />
  )
}
